export default __webpack_public_path__ + "static/media/printerIcon.034480b0.svg";